import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MentionedUser } from '../../../application/interfaces';

@Pipe({
  name: 'messageTextFormat',
  standalone: true,
  pure: true
})
export class MessageTextFormatPipe implements PipeTransform {
  private static readonly URL_REGEX: RegExp = /(https?:\/\/[^\s<]+|www\.[^\s<]+)/g;

  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(text: string, mentionedUsers: MentionedUser[], currentUserId?: string): SafeHtml {
    if (!text) {
      return '';
    }

    let result: string = this.escapeHtml(text);
    result = this.linkifyUrls(result);
    result = this.highlightMentions(result, mentionedUsers, currentUserId);

    return this.sanitizer.bypassSecurityTrustHtml(result);
  }

  private escapeHtml(text: string): string {
    return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  private linkifyUrls(escapedText: string): string {
    return escapedText.replace(MessageTextFormatPipe.URL_REGEX, (url: string) => {
      const href: string = url.startsWith('www.') ? `https://${url}` : url;
      return `<a href="${href}" target="_blank" rel="noopener noreferrer" class="message-link">${url}</a>`;
    });
  }

  private highlightMentions(text: string, mentionedUsers: MentionedUser[], currentUserId?: string): string {
    if (!mentionedUsers?.length) {
      return text;
    }

    const sorted: MentionedUser[] = [...mentionedUsers].sort(
      (a: MentionedUser, b: MentionedUser) => b.name.length - a.name.length
    );

    for (const user of sorted) {
      const escapedName: string = this.escapeHtml(user.name);
      const isSelf: boolean = !!currentUserId && user.id === currentUserId;
      const cssClass: string = isSelf ? 'mention mention-self' : 'mention';
      const regex: RegExp = new RegExp(`@${this.escapeRegex(escapedName)}`, 'g');
      text = text.replace(regex, `<span class="${cssClass}">${escapedName}</span>`);
    }

    return text;
  }

  private escapeRegex(text: string): string {
    return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
}
